/** Servis kaydı durum renkleri — badge ve pill filtreleri */
export const SERVICE_RECORD_STATUS_COLORS = {
  Taslak: '#64748b',
  Yeni: '#3b82f6',
  'Randevu Bekliyor': '#f59e0b',
  'Randevu Bekleniyor': '#f59e0b',
  'Randevu Tarihi Bekleniyor': '#6366f1',
  'Sipariş Bekleniyor': '#8b5cf6',
  Atandı: '#10b981',
  'Devam Ediyor': '#6366f1',
  İşlemde: '#10b981',
  Tamamlandı: '#059669',
  'Randevu Tamamlandı': '#059669',
  'İptal Edildi': '#ef4444',
  'Randevu İptal Edildi': '#ef4444',
  'Randevu Süresi Geçmiş': '#dc2626',
  Açık: '#3b82f6',
  Çözüldü: '#059669',
};

export const getServiceRecordStatusColor = (durum) =>
  SERVICE_RECORD_STATUS_COLORS[durum] || '#64748b';
